import { render } from "./WhyArea.vue?vue&type=template&id=40cd287b"
import script from "./WhyArea.vue?vue&type=script&lang=js"
export * from "./WhyArea.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__